import { useMemo } from 'react'
import { ASPECT_RATIOS_SEARCH_INDEX } from './constants'
import { ASPECT_RATIOS, AspectRatioKey } from 'components/NewFileModal/Types'
import { SearchResultsProps } from './Types'
import { AspectRatio } from './AspectRatio'
import Styles from './DesignAspectRatioPickerModal.module.scss'
import { Empty } from 'components/Wizards/Catalogue/Empty'

const searchAspectRatios = (query: string): Array<AspectRatioKey> => {
  const lowerCaseQuery = query.toLowerCase()

  return (Object.keys(ASPECT_RATIOS_SEARCH_INDEX) as AspectRatioKey[]).filter((key) =>
    ASPECT_RATIOS_SEARCH_INDEX[key].some((value) => value.toLowerCase().includes(lowerCaseQuery)),
  )
}

export const SearchResults = ({ query, onSelect }: SearchResultsProps) => {
  const results = useMemo(() => searchAspectRatios(query), [query])

  const noResults = results.length === 0

  return (
    <div className={Styles.searchResultsContainer}>
      {noResults ? (
        <Empty query={query} />
      ) : (
        <div className={Styles.searchResults}>
          {results.map((key) => (
            <AspectRatio key={key} {...ASPECT_RATIOS[key]} onSelect={() => onSelect(key)} />
          ))}
        </div>
      )}
    </div>
  )
}
